"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLockSubscription = useLockSubscription;
exports.useFocusReturn = useFocusReturn;
exports.useLockLayer = useLockLayer;
exports.useFocusLock = useFocusLock;
exports.FocusGuard = exports["default"] = exports.LOCK_STACK = void 0;

var React = _interopRequireWildcard(require("react"));

var _LockStack = _interopRequireDefault(require("./LockStack"));

var _wrapFocus = _interopRequireDefault(require("./util/wrapFocus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// This global ensures that only one stack exists in the document. Having multiple
// active stacks does not make sense, as documents are only capable of having one
// activeElement at a time.
var LOCK_STACK = new _LockStack["default"]();
exports.LOCK_STACK = LOCK_STACK;
var lockCount = 0;

function newLockUID() {
  return "lock-".concat(lockCount++);
}
/**
 * Creates a subscription to the lock stack that is bound to the lifetime
 * of the caller, based on `useEffect`.
 */


function useLockSubscription(callback) {
  // `subscribe` returns an `unsubscribe` function that `useEffect` can invoke
  // to clean up the subscription.
  React.useEffect(function () {
    return LOCK_STACK.subscribe(callback);
  }, [callback]);
}
/**
 * Set up a return of focus to the target element specified by `returnTo` to
 * occur at the end of the lifetime of the caller component. In other words,
 * return focus to where it was before the caller component was mounted.
 */


function useFocusReturn(returnRef, disabledRef) {
  // This isn't necessarily safe, but realistically it's sufficient.
  var _React$useState = React.useState(function () {
    return document.activeElement;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      target = _React$useState2[0];

  React.useLayoutEffect(function () {
    return function () {
      if (disabledRef != null && disabledRef.current) return; // Happens on next tick to ensure it is not overwritten by focus lock.

      if (returnRef != null && returnRef.current != null) {
        returnRef.current.focus();
        return;
      }

      target != null && target.focus();
    }; // Explicitly only want this to run on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
/**
 * Create and push a new lock onto the global LOCK_STACK, tied to the lifetime
 * of the caller. Returns a ref containing the current enabled state of the
 * layer, to be used for enabling/disabling the caller's lock logic.
 */


function useLockLayer(controlledUID) {
  var _React$useState3 = React.useState(function () {
    return controlledUID || newLockUID();
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      uid = _React$useState4[0];

  var enabledRef = React.useRef(false); // When first created, immediately disable the current layer (the one below
  // this new one) to prevent its handlers from stealing focus back when this
  // layer mounts. Specifically, this allows `autoFocus` to work, since React
  // will perform the autofocus before any effects have run.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  var _ = React.useState(function () {
    return LOCK_STACK.toggleLayer(LOCK_STACK.current(), false);
  });

  React.useLayoutEffect(function () {
    LOCK_STACK.add(uid, function (enabled) {
      return enabledRef.current = enabled;
    });
    return function () {
      return LOCK_STACK.remove(uid);
    };
  }, [uid]);
  return enabledRef;
}

function useFocusLock(containerRef) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var returnRef = options.returnRef,
      disableReturnRef = options.disableReturnRef,
      _options$attachToRef = options.attachToRef,
      attachToRef = _options$attachToRef === void 0 ? containerRef : _options$attachToRef,
      disable = options.disable; // Create a new layer for this lock to occupy

  var enabledRef = useLockLayer(); // Allow the caller to override the lock and force it to be disabled.

  React.useEffect(function () {
    if (!disable) return;
    enabledRef.current = false;
  }, [disable]); // Apply the actual lock logic to the container.

  React.useLayoutEffect(function () {
    // Move focus into the container if it is not already, or if an element
    // inside of the container will automatically receive focus, it won't be moved.
    var container = containerRef.current;

    if (container != null && document.activeElement != null && !container.contains(document.activeElement) && container.querySelector('[autofocus]') == null) {
      (0, _wrapFocus["default"])(container, document.activeElement, true);
    }

    function handleFocusIn(event) {
      if (!enabledRef.current) return;
      var root = containerRef.current;
      if (root == null) return;
      var newFocusElement = event.target || document.body;
      if (root.contains(newFocusElement)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      (0, _wrapFocus["default"])(root, newFocusElement);
    }

    function handleFocusOut(event) {
      if (!enabledRef.current) return;
      var root = containerRef.current;
      if (root == null) return;
      var newFocusElement = event.relatedTarget || document.body;

      if (event.relatedTarget === document.body) {
        event.preventDefault();
        root.focus();
      }

      if (root.contains(newFocusElement)) return;
      (0, _wrapFocus["default"])(root, newFocusElement);
    }

    var attachTo = attachToRef.current;
    if (attachTo == null) return undefined;
    attachTo.addEventListener('focusin', handleFocusIn, {
      capture: true
    });
    attachTo.addEventListener('focusout', handleFocusOut, {
      capture: true
    });
    return function () {
      attachTo.removeEventListener('focusin', handleFocusIn, {
        capture: true
      });
      attachTo.removeEventListener('focusout', handleFocusOut, {
        capture: true
      });
    };
  }, [containerRef, attachToRef]); // Set up a focus return after the container is unmounted.
  // This happens at the end to absolutely ensure that the return is the last
  // thing that will run as part of this hook (i.e., that the focus handlers
  // have been fully detached).

  useFocusReturn(returnRef, disableReturnRef);
}

var _default = useFocusLock;
/**
 * A convenience component for rendering "guard elements" that ensure there is
 * always a tabbable element either before or after (or both) an active lock.
 * These are most easily rendered right at the edges of the React rendering root
 * so that all locks can utilize the same guards.
 *
 * When no lock is active, `FocusGuard` is completely invisible, both visually
 * and in the focus order. When active, it gets a tabindex, but always remains
 * visually hidden.
 */

exports["default"] = _default;
var FocusGuard = /*#__PURE__*/React.memo(function () {
  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      active = _React$useState6[0],
      setActive = _React$useState6[1];

  useLockSubscription(function (newActiveState) {
    return setActive(newActiveState);
  });
  return /*#__PURE__*/React.createElement("div", {
    tabIndex: active ? 0 : undefined,
    style: {
      position: 'fixed',
      opacity: 0,
      pointerEvents: 'none'
    }
  });
});
exports.FocusGuard = FocusGuard;